import { Button } from "antd";
import React, { useContext, useEffect } from "react";

import { FiEdit2 } from "react-icons/fi";

import CookieModal from "../../Components/CookieModal/CookieModal";
import { FeatureFlag } from "../../Components/FeatureFlag/FeatureFlag";
import Layout from "../../Components/Layout/Layout";
import MostLikesCategories from "../../Components/MostLikesCategories/MostLikesCategories";
import BetaSlider from "../../Components/Sliders/BetaSlider/BetaSlider";
import ProductSlider from "../../Components/Sliders/ProductSlider/ProductSlider";
import { AuthContext } from "../../Contexts/AuthContext";
import { ConfigContext } from "../../Contexts/ConfigContext";
import {
  useDiscountedProducts,
  useProductsBySubCategory,
  useSubCategories,
} from "../../Hooks/useProductsBySubCategory";
import { hasAcceptedCookies } from "../../utils/storage";
import styles from "./LandingV2.module.scss";

import { regional_recipes_slider, upcoming_categories_slider } from "./data";

import map_pin from "./images/map-pin.svg";
import navigator from "./images/navigator.svg";
import CategoriesSlider from "../../Components/Sliders/CategoriesSlider/CategoriesSlider";

import { GoogleReviewSlider } from "./components/GoogleReviewSlider";
import BannerWebsite from "../../Components/BannerWebsite/BannerWebsite";
import { RecommendedProducts } from "./components/RecommendedProducts";
import { LifeChangeSlider } from "./components/LifeChangeSlider";
import { BestSellingProducts } from "./components/BestSellingProducts";
import { CouponSlider } from "./components/CouponSlider";
import { BringChangeSlider } from "./components/BringChangeSlider";
import { PopularBrandsSlider } from "./components/PopularBrandsSlider";
import { JoinWhatsapp } from "./components/JoinWhatsApp";
import { LandingFAQ } from "./components/LandingFAQ";

export {
  RecommendedProducts,
  BestSellingProducts,
  LifeChangeSlider,
  CouponSlider,
  BringChangeSlider,
  PopularBrandsSlider,
  JoinWhatsapp,
  LandingFAQ,
  GoogleReviewSlider,
};

const LandingV2 = () => {
  const { location } = useContext(AuthContext);
  const { showCookieModal, setShowCookieModal, setShowLocModal } =
    useContext(ConfigContext);

  const { categories } = useSubCategories();
  const discounted = useDiscountedProducts();
  const fruitsAndVegetables = useProductsBySubCategory(22);
  const staples = useProductsBySubCategory(35);
  const frozenFood = useProductsBySubCategory(13);
  const eggMeatFish = useProductsBySubCategory(25);
  const milkDairyBread = useProductsBySubCategory(33);
  const snacksAndNamkeen = useProductsBySubCategory(38);
  const spicesHerbsSeasonings = useProductsBySubCategory(37);

  // after 2 seconds, show cookie modal - but only to a visitor who has never
  // answered it on this browser, logged in or not
  useEffect(() => {
    if (hasAcceptedCookies()) return;

    const timer = setTimeout(() => {
      setShowCookieModal(true);
    }, 2000);

    return () => {
      clearTimeout(timer);
      setShowCookieModal(false);
    };
  }, [setShowCookieModal]);

  return (
    <Layout>
      {/*Free Shipping*/}
      <div className="pt-3 d-lg-none"></div>

      <div
        className={styles.location + " mb_only"}
        onClick={() => setShowLocModal(true)}
      >
        {location?.city ? (
          <>
            <div>
              <img src={map_pin} alt="map_pin" />
              <div>
                <span className="fw-bold ">Delivering to: </span>
                <span className="fw-medium">
                  {location.zip}, {location.city}
                </span>
              </div>
            </div>

            <div>
              <FiEdit2 size={18} />
            </div>
          </>
        ) : (
          <div>
            <img src={navigator} alt="navigator" />
            <div>
              <span className="fw-bold ">Enter your delivery address here</span>
            </div>
          </div>
        )}
      </div>

      <BannerWebsite />

      <div className="d-none d-lg-block mt-5" />
      {window.innerWidth <= 576 && <CategoriesSlider categories={categories} />}
      <div className="container">
        <ProductSlider
          title={"Discounts & Offers"}
          link={"category/discounts-offers-juc442_7"}
          products={discounted.products}
          loading={discounted.loading}
          showDiscountVariants
        />
      </div>

      <FeatureFlag name="landingCouponSection">
        <div className="mt-5" />
        <CouponSlider />
      </FeatureFlag>

      <div className="container mt-5">
        <ProductSlider
          title={"Fruits & Vegetables"}
          link={"/"}
          products={fruitsAndVegetables.products}
          loading={fruitsAndVegetables.loading}
        />
      </div>

      <div className="mt-5" />
      <LifeChangeSlider />

      <div className="container px-0 mt-5">
        <MostLikesCategories />
      </div>

      <div className="container mt-5">
        <ProductSlider
          title={"Staples"}
          link={"/"}
          products={staples.products}
          loading={staples.loading}
        />
      </div>

      <div className="container mt-5">
        <ProductSlider
          title={"Frozen Food"}
          link={"/"}
          products={frozenFood.products}
          loading={frozenFood.loading}
        />
      </div>

      <div className="container mt-5">
        <ProductSlider
          title={"Egg, Meat & Fish"}
          link={"/"}
          products={eggMeatFish.products}
          loading={eggMeatFish.loading}
        />
      </div>

      <div className="container mt-5">
        <ProductSlider
          title={"Milk, Dairy & Bread"}
          link={"/"}
          products={milkDairyBread.products}
          loading={milkDairyBread.loading}
        />
      </div>

      <div className="container mt-5">
        <ProductSlider
          title={"Snacks & Namkeen"}
          link={"/"}
          products={snacksAndNamkeen.products}
          loading={snacksAndNamkeen.loading}
        />
      </div>

      <div className="container mt-5">
        <ProductSlider
          title={"Spices, Herbs & Seasonings"}
          link={"/"}
          products={spicesHerbsSeasonings.products}
          loading={spicesHerbsSeasonings.loading}
        />
      </div>

      {/*Regional Recipes*/}
      <FeatureFlag name="landingRegionalRecipesSection">
        <BetaSlider
          slides={regional_recipes_slider}
          title={"Regional Recipes"}
          link={"/"}
        />
      </FeatureFlag>

      {/*Delivery Location Map*/}
      {window.innerWidth > 576 ? (
        <section className={styles.delivery_map}>
          <h2>We deliver across Germany</h2>
          <img src="/delivery-map.png" alt="" loading="lazy" decoding="async" />
          <div>
            <div>
              <em>Where are you based?</em>
              <span>Help us to deliver you fast</span>
              <Button type={"primary"} onClick={() => setShowLocModal(true)}>
                Choose Location
              </Button>
            </div>
          </div>
        </section>
      ) : (
        <section className={styles.delivery_map}>
          <h2>We deliver across Germany</h2>
          <div>
            <img src="/delivery-map.png" alt="" loading="lazy" decoding="async" />
            <div>
              <em>Where are you based?</em>

              <span>Help us to deliver you fast</span>
              <Button type={"primary"} onClick={() => setShowLocModal(true)}>
                Choose Location
              </Button>
            </div>
          </div>
        </section>
      )}

      <BringChangeSlider />

      <div className="container mt-5">
        <RecommendedProducts />
      </div>

      <div className="container mt-5">
        <BestSellingProducts />
      </div>

      <div className="mt-5"></div>
      <PopularBrandsSlider />

      {window.innerWidth > 576 && (
        <BetaSlider
          slides={upcoming_categories_slider}
          title={`Upcoming Categories`}
          link={"/"}
        />
      )}

      {/*Whatsapp Section*/}
      <JoinWhatsapp />

      {/*Review Section*/}
      {/*<GoogleReviewSlider />*/}

      {/*FAQ Section*/}
      <LandingFAQ />

      {/* Cookie Modal */}
      {showCookieModal && (
        <CookieModal
          showModal={showCookieModal}
          setShowModal={setShowCookieModal}
        />
      )}
    </Layout>
  );
};

export default LandingV2;
